"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function JoinOurCareTeam() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const stats = [{
    value: "15 yrs",
    label: "DDS Service"
  }, {
    value: "200+",
    label: "Caregivers"
  }, {
    value: "State",
    label: "Qualified"
  }];
  return <section data-section-id="34" id="join-our-care-team" className="relative overflow-hidden bg-background text-foreground">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.04]" style={{
      backgroundImage: "repeating-linear-gradient(45deg, var(--foreground) 0px, var(--foreground) 1px, transparent 1px, transparent 6px)"
    }} aria-hidden="true" />

      <div className="relative mx-auto max-w-7xl px-6 py-20 sm:px-8 sm:py-28 lg:py-32">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-10">
          {}
          <div ref={contentRef} className={`lg:col-span-7 transition-all duration-1000 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            {}
            <div className="flex items-center gap-3 font-default">
              <span className="h-px w-8" style={{
              backgroundColor: "var(--accent)"
            }} aria-hidden="true" />
              <span className="text-[12px] font-medium uppercase" style={{
              color: "var(--accent)",
              letterSpacing: "0.18em"
            }}>
                Careers at Waters Well
              </span>
            </div>

            {}
            <h1 className="mt-8 font-default text-foreground font-normal" style={{
            fontSize: "clamp(2.75rem, 8vw, 7rem)",
            lineHeight: "1.02",
            letterSpacing: "-0.03em"
          }}>
              <span className="block !text-center">Empowering lives through dedicated support</span>
              
              
            </h1>

            {}
            <p className="mt-4 max-w-[520px] font-default text-muted-foreground !text-left" style={{
            fontSize: "19px",
            lineHeight: "1.6"
          }}>
              Join our team of qualified professionals in Connecticut. We provide 
              essential support services with empathy, precision, and a commitment 
              to individual growth.
            </p>

            <Button className="mt-8" onClick={() => {
            const element = document.getElementById('application-section');
            if (element) {
              element.scrollIntoView({
                behavior: 'smooth'
              });
            }
          }}>
              Apply <ArrowRight className="ml-2" />
            </Button>

            {}
            <Separator className="mt-6 bg-border" />

            {}
            
          </div>

          {}
          <div ref={imageRef} className={`relative lg:col-span-5 lg:-mr-20 transition-all duration-1000 ease-out ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: "200ms"
        }}>
            <div className="relative">
              {}
              <div className="absolute -bottom-6 -right-6 hidden border lg:block rounded-lg" style={{
              borderColor: "var(--primary)",
              top: "24px",
              left: "24px"
            }} aria-hidden="true" />

              {}
              <div className="relative overflow-hidden rounded-lg">
                
              </div>

              {}
              
            </div>
          </div>
        </div>
      </div>
    </section>;
}